"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconNetwork = /*#__PURE__*/
function (_Icon) {
  _inherits(IconNetwork, _Icon);
  function IconNetwork(props) {
    var _this;
    _classCallCheck(this, IconNetwork);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconNetwork).call(this, props));
    _this.name = 'IconNetwork';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("path", {
      className: "network_svg__path0",
      d: "M16.6 12.635a.248.248 0 00-.08-.237 2.233 2.233 0 01-.769-1.68 2.125 2.125 0 01.084-.578.25.25 0 00-.09-.267A8.8 8.8 0 0011 8.218a.734.734 0 01-.081-.005.25.25 0 00-.268.181 2.5 2.5 0 01-2.4 1.824.045.045 0 00-.045.037 12.255 12.255 0 00-.093 3.86.251.251 0 00.208.214 21.285 21.285 0 016.362 2.118.252.252 0 00.32-.079 10.091 10.091 0 001.597-3.733z"
    }), _react2.default.createElement("path", {
      className: "network_svg__path1",
      d: "M13.616 17.968a.249.249 0 00-.063-.407A19.694 19.694 0 008.91 15.98a.25.25 0 00-.287.325 10.271 10.271 0 00.548 1.328 10.69 10.69 0 001.619 2.28.249.249 0 00.32.044 29.115 29.115 0 002.506-1.989z"
    }), _react2.default.createElement("path", {
      className: "network_svg__path2",
      d: "M6.3 14.105a.25.25 0 00.265-.274 13.048 13.048 0 01.205-4.045.062.062 0 00-.022-.07 2.5 2.5 0 01-.777-.982.25.25 0 00-.271-.149A11 11 0 00.1 11.4a.255.255 0 00-.075.163c-.008.135-.02.269-.02.406a11.907 11.907 0 00.246 2.381.256.256 0 00.111.161.249.249 0 00.192.032 19.925 19.925 0 015.746-.438z"
    }), _react2.default.createElement("path", {
      className: "network_svg__path3",
      d: "M9.231 20.914a.25.25 0 00.1-.393 11.528 11.528 0 01-1.5-2.219 12.238 12.238 0 01-.911-2.466.248.248 0 00-.22-.187 18.874 18.874 0 00-5.69.331.25.25 0 00-.166.126.254.254 0 00-.012.209 12.046 12.046 0 004.132 5.353.253.253 0 00.15.048 11.355 11.355 0 004.117-.802z"
    }), _react2.default.createElement("path", {
      className: "network_svg__path4",
      d: "M18.931 12.956l-.006-.007a.249.249 0 00-.268-.083 2.2 2.2 0 01-.409.082.251.251 0 00-.218.2c-.582 2.66-2.127 5.349-5.749 7.842a.249.249 0 00-.026.391 28.684 28.684 0 002.662 2.119.247.247 0 00.209.037 12.011 12.011 0 006.456-4.378.249.249 0 00.048-.188 13.51 13.51 0 00-2.699-6.015z"
    }), _react2.default.createElement("path", {
      className: "network_svg__path5",
      d: "M5.7 7.058a.254.254 0 00.2-.165 2.488 2.488 0 012.078-1.648.093.093 0 00.078-.062 19.735 19.735 0 013.055-4.74.25.25 0 00-.211-.41A12.009 12.009 0 00.5 8.591a.25.25 0 00.374.281A12.912 12.912 0 015.7 7.058z"
    }), _react2.default.createElement("path", {
      className: "network_svg__path6",
      d: "M10.774 22.052a.249.249 0 00-.279-.046 12.6 12.6 0 01-2.366.833.25.25 0 00-.022.479 11.923 11.923 0 003.893.65c.1 0 .2 0 .3-.007a.25.25 0 00.147-.444c-.526-.424-1.1-.917-1.673-1.465z"
    }), _react2.default.createElement("path", {
      className: "network_svg__path7",
      d: "M18.748 8.436a.249.249 0 00.149.228 2.246 2.246 0 011.353 2.054 2.194 2.194 0 01-.23.972.25.25 0 00.042.281l.007.008a15.017 15.017 0 012.519 4.6.249.249 0 00.467.018A11.868 11.868 0 0024 11.968a12.005 12.005 0 00-5.78-10.259.25.25 0 00-.373.274 28.4 28.4 0 01.901 6.453z"
    }), _react2.default.createElement("path", {
      className: "network_svg__path8",
      d: "M9.613 5.38a.25.25 0 00.081.309 2.51 2.51 0 01.8.936.249.249 0 00.3.127.631.631 0 01.206-.034 10.245 10.245 0 015.69 1.991.251.251 0 00.267.024c.046-.024.093-.047.141-.067a.251.251 0 00.151-.23A29.982 29.982 0 0015.961.764.251.251 0 0015.8.6a11.925 11.925 0 00-2.21-.518.252.252 0 00-.214.076A22.455 22.455 0 009.613 5.38z"
    }));
    return _this;
  }
  return IconNetwork;
}(_Icon3.default);
exports.default = IconNetwork;